export enum ChromosomeArm {
	ShortArm = "ShortArm",
	Centromere = "Centromere",
	LongArm = "LongArm",
}
